module.exports = __webpack_public_path__ + "img/ios.1751892.svg";